<div class="h-full bg-gray-50 flex overflow-hidden">
  <!-- Sidebar reduze-->
  <!-- <button (click)="toggleSidebar()" class="lg:hidden p-2 absolute">
        <lucide-icon [img]="Menu"></lucide-icon>
      </button> -->
  <aside
    class="h-full lg:hidden top-16 inset-y-0 left-0 z-50 w-15 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out flex-shrink-0">
    <div class="h-full flex flex-col overflow-hidden">
      <!-- Logo e Toggle -->
      <div class="h-16 flex items-center justify-between px-4 border-b border-gray-200 flex-shrink-0">

        <button (click)="toggleSidebar()" class="lg:hidden p-1 rounded-lg hover:bg-gray-100">
          <lucide-icon [img]="ChevronLeft" [size]="20" class="text-gray-600"></lucide-icon>
        </button>
      </div>

      <!-- Menu Items -->
      <nav class="flex-1 overflow-y-auto py-4 px-3 min-h-0">
        <div class="space-y-1">
          <!-- <a *ngFor="let item of filteredMenuItems()" (click)="navigateToPage(item.key)"
            class="flex items-center justify-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors"
            [class.bg-gray-900]="isActiveRoute(item.key)" [class.text-white]="isActiveRoute(item.key)"
            [class.hover:bg-gray-100]="!isActiveRoute(item.route)" [class.text-gray-700]="!isActiveRoute(item.key)"
            [class.display-hidden]="!isMenuItemActive(item.key)">
            <lucide-icon [img]="item.icon" [size]="18"></lucide-icon>
          </a>  -->
           <a *ngFor="let item of filteredMenuItemCollapsed()" (click)="navigateToPage(item.key)"
            class="flex items-center justify-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors"
            [class.bg-gray-900]="isActiveRoute(item.key)" [class.text-white]="isActiveRoute(item.key)"
            [class.hover:bg-gray-100]="!isActiveRoute(item.route)" [class.text-gray-700]="!isActiveRoute(item.key)"
            [class.display-hidden]="!isMenuItemActive(item.key)">
            <lucide-icon [img]="item.icon" [size]="18"></lucide-icon>
          </a> 
        </div>
      </nav>

      <!-- User Info & Logout -->
      <div class="border-t border-gray-200 p-4 flex-shrink-0">
        <div class="flex items-center space-x-3 mb-3">
          <div class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
            <span class="text-sm font-medium text-gray-600">
              {{ getUserInitials() }}
            </span>
          </div>

        </div>
        <button (click)="logout()"
          class="w-full flex items-center px-3 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100 transition-colors">
          <lucide-icon [img]="LogOut" [size]="18"></lucide-icon>

        </button>
      </div>
    </div>
  </aside>
  <!-- SideBar Large -->
  <aside
    class="fixed lg:static inset-y-0 left-0 z-50 h-full w-64 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:flex-shrink-0 flex flex-col overflow-hidden"
    [class.-translate-x-full]="!sidebarOpen">
    <!-- Logo e Toggle -->
    <div class="h-16 flex items-center justify-between px-4 border-b border-gray-200 flex-shrink-0">
      <div class="flex items-center space-x-2">
        <span class="font-semibold text-gray-800">Dashboard</span>
      </div>
      <button class="lg:hidden p-1 rounded-lg hover:bg-gray-100">
        <lucide-icon [img]="ChevronLeft" [size]="20" class="text-gray-600"></lucide-icon>
      </button>
    </div>

    <!-- Menu Items — scroll apenas aqui -->
    <nav class="flex-1 overflow-y-auto py-4 px-3 min-h-0">
      <div class="space-y-1">

        <a *ngFor="let item of filteredMenuItems()" (click)="navigateToPage(item.key)"
          class="flex items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors"
          [class.bg-gray-900]="isActiveRoute(item.key)" [class.text-white]="isActiveRoute(item.key)"
          [class.hover:bg-gray-100]="!isActiveRoute(item.route)" [class.text-gray-700]="!isActiveRoute(item.key)"
          [class.display-hidden]="!isMenuItemActive(item.key)">
          <lucide-icon [img]="item.icon" [size]="18" class="mr-3"></lucide-icon>
          <span class="flex-1">{{ item.label }}</span>
          <span *ngIf="item.badge && item.badge > 0" class="ml-2 px-2 py-0.5 text-xs font-medium rounded-full"
            [class.bg-white]="isActiveRoute(item.key)" [class.text-gray-900]="isActiveRoute(item.key)"
            [class.bg-gray-200]="!isActiveRoute(item.key)" [class.text-gray-700]="!isActiveRoute(item.key)">
            {{ item.badge }}
          </span>
        </a>

        <!-- Grupo Dispositivos (colapsável) -->
        @if(hasDispositivosItems()){
        <button (click)="toggleDispositivosCollapsed()"
          class="flex transition justify-between w-full items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors">
            <div class="flex gap-6">
              <lucide-icon [img]="Smartphone" [size]="18"></lucide-icon>
              <p>Dispositivos</p>
            </div>
          @if(isDispositivosCollapsed()){
            <lucide-icon [img]="ChevronUp" [size]="18" class="mr-3 transition"></lucide-icon>
          } @else {
             <lucide-icon [img]="ChevronDown" [size]="18" class="mr-3 transition"></lucide-icon>
          }
        </button>
        @if(isDispositivosCollapsed()){
          <div class="pl-4 transition">
            <a *ngFor="let item of filteredDispositivosItems()" (click)="navigateToPage(item.key)"
              class="flex items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors"
              [class.bg-gray-900]="isActiveRoute(item.key)" [class.text-white]="isActiveRoute(item.key)"
              [class.hover:bg-gray-100]="!isActiveRoute(item.route)" [class.text-gray-700]="!isActiveRoute(item.key)">
              <lucide-icon [img]="item.icon" [size]="18" class="mr-1"></lucide-icon>
              <span class="flex-1">{{ item.label }}</span>
            </a>
          </div>
         }
        }

        <!-- Grupo Visitas (colapsável) -->
        @if(hasAccessItems()){
        <button (click)="toggleCollapsed()"
          class="flex transition justify-between w-full items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors">
          <div class="flex gap-6">
            <lucide-icon [img]="House" [size]="18"></lucide-icon>
            <p>Visitas</p>
          </div>
          @if(isCollapsed()){
            <lucide-icon [img]="ChevronUp" [size]="18" class="mr-3 transition"></lucide-icon>
          } @else {
            <lucide-icon [img]="ChevronDown" [size]="18" class="mr-3 transition"></lucide-icon>
          }
        </button>
        @if(isCollapsed()){
          <div class="pl-4 transition">
            <a *ngFor="let item of filteredAccessItems()" (click)="navigateToPage(item.key)"
              class="flex items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors"
              [class.bg-gray-900]="isActiveRoute(item.key)" [class.text-white]="isActiveRoute(item.key)"
              [class.hover:bg-gray-100]="!isActiveRoute(item.route)" [class.text-gray-700]="!isActiveRoute(item.key)"
              [class.display-hidden]="!isMenuItemActive(item.key)">
              <lucide-icon [img]="item.icon" [size]="18" class="mr-1"></lucide-icon>
              <span class="flex-1">{{ item.label }}</span>
              <span *ngIf="item.badge && item.badge > 0" class="ml-2 px-2 py-0.5 text-xs font-medium rounded-full"
                [class.bg-white]="isActiveRoute(item.key)" [class.text-gray-900]="isActiveRoute(item.key)"
                [class.bg-gray-200]="!isActiveRoute(item.key)" [class.text-gray-700]="!isActiveRoute(item.key)">
                {{ item.badge }}
              </span>
            </a>
          </div>
          }
        }
        <!-- Utilizadores -->
        @if(hasUserItems()){
          <button (click)="toggleCollapsedUser()"
            class="flex transition justify-between w-full items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors">
            <div class="flex gap-6">
              <lucide-icon [img]="House" [size]="18"></lucide-icon>
              <p>Utilizadores</p>
            </div>
              @if(isCollapsedUser()){
                <lucide-icon [img]="ChevronUp" [size]="18" class="mr-3 transition"></lucide-icon>
              } @else {
                <lucide-icon [img]="ChevronDown" [size]="18" class="mr-3 transition"></lucide-icon>
              }
          </button>
        @if(isCollapsedUser()){
          <div class="pl-4 transition">
            <a *ngFor="let item of filteredUserItems()" (click)="navigateToPage(item.key)"
              class="flex items-center px-3 py-2.5 text-sm font-medium rounded-lg cursor-pointer transition-colors"
              [class.bg-gray-900]="isActiveRoute(item.key)" [class.text-white]="isActiveRoute(item.key)"
              [class.hover:bg-gray-100]="!isActiveRoute(item.route)" [class.text-gray-700]="!isActiveRoute(item.key)"
              [class.display-hidden]="!isMenuItemActive(item.key)">
              <lucide-icon [img]="item.icon" [size]="18" class="mr-1"></lucide-icon>
              <span class="flex-1">{{ item.label }}</span>
              <span *ngIf="item.badge && item.badge > 0" class="ml-2 px-2 py-0.5 text-xs font-medium rounded-full"
                [class.bg-white]="isActiveRoute(item.key)" [class.text-gray-900]="isActiveRoute(item.key)"
                [class.bg-gray-200]="!isActiveRoute(item.key)" [class.text-gray-700]="!isActiveRoute(item.key)">
                {{ item.badge }}
              </span>
            </a>
          </div>
          }
        }
      </div>
    </nav>

    <!-- User Info & Logout — fixo no fundo -->
    <div class="border-t border-gray-200 p-4 flex-shrink-0">
      <div class="flex items-center space-x-3 mb-3">
        <div class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
          <span class="text-sm font-medium text-gray-600">
            {{ getUserInitials() }}
          </span>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-900 truncate">
            {{ (authService.getCurrentUser()?.first_name) || 'Usuário' }}
          </p>
          <p class="text-xs text-gray-500 truncate">
            {{ authService.getCurrentUser()?.role || 'Administrador' }}
          </p>
        </div>
      </div>
      <button (click)="logout()"
        class="w-full flex items-center px-3 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100 transition-colors">
        <lucide-icon [img]="LogOut" [size]="18" class="mr-3"></lucide-icon>
        Sair
      </button>
    </div>
  </aside>

  <!-- Mobile Overlay -->
  <div *ngIf="sidebarOpen" (click)="sidebarOpen = false" class="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden">
  </div>

  <!-- Main Content — scroll apenas aqui, sidebar fica fixa -->
  <div class="flex-1 min-w-0 min-h-0 flex flex-col">
    <main class="flex-1 min-h-0 overflow-y-auto p-4 lg:p-6">
      <div *ngIf="activeSection.key=='dashboard'" class="max-w-7xl mx-auto">
        <!-- Postos e Check-ins de Hoje -->
        <ng-container *ngIf="canShowPositionsTable$ | async">
          <div class="bg-white rounded-lg border border-gray-200 shadow-sm mb-6 overflow-hidden"
            *ngIf="positionsWithCheckins$ | async as positionsData">
            <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
              <div class="flex items-center space-x-2">
                <lucide-icon [img]="MapPin" [size]="20" class="text-gray-600"></lucide-icon>
                <div>
                  <h2 class="text-lg font-semibold text-gray-800">Postos e Check-Presence de Hoje</h2>
                  <p class="text-sm text-gray-500">Status dos postos e notificações</p>
                </div>
              </div>
            </div>

            <div class="overflow-x-auto">
              <table class="w-full">
                <thead class="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Posto
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Localização</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total
                      Hoje</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Válidos
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Inválidos
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acções
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let position of positionsData; trackBy: trackByPositionId"
                    class="hover:bg-gray-50 transition-colors">
                    <td class="px-6 py-4">
                      <div class="flex items-center space-x-2">
                        <lucide-icon [img]="MapPin" [size]="16" class="text-gray-400"></lucide-icon>
                        <span class="text-sm font-medium text-gray-900">{{ position.name }}</span>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-500">{{ position.location }}</td>
                    <td class="px-6 py-4">
                      <div class="flex items-center space-x-1">
                        <lucide-icon [img]="Clock" [size]="14" class="text-gray-400"></lucide-icon>
                        <span class="text-sm font-medium text-gray-900">{{ position.todayCheckinsCount || 0 }}</span>
                      </div>
                    </td>
                    <td class="px-6 py-4">
                      <div class="flex items-center space-x-1 text-green-600">
                        <lucide-icon [img]="CheckCircle" [size]="14"></lucide-icon>
                        <span class="text-sm font-medium">{{ position.validCheckinsCount || 0 }}</span>
                      </div>
                    </td>
                    <td class="px-6 py-4">
                      <div class="flex items-center space-x-1 text-red-600">
                        <lucide-icon [img]="XCircle" [size]="14"></lucide-icon>
                        <span class="text-sm font-medium">{{ position.invalidCheckinsCount || 0 }}</span>
                      </div>
                    </td>
                    <td class="px-6 py-4">
                      <button
                        class="inline-flex items-center px-3 py-1.5 bg-gray-900 text-white text-sm font-medium rounded-md hover:bg-gray-800 transition-colors"
                        (click)="sendPushNotification(position.id, position.name)">
                        <lucide-icon [img]="Bell" [size]="14" class="mr-1.5"></lucide-icon>
                        Notificar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Empty State -->
              <div *ngIf="!positionsData || positionsData.length === 0" class="text-center py-12">
                <p class="text-gray-500">Nenhum posto encontrado</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Stats Cards Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <div *ngFor="let card of dashboardCards$ | async; trackBy: trackByCardTitle"
            (click)="navigateToPage(card.key)"
            class="bg-white rounded-lg border border-gray-200 shadow-sm p-6 cursor-pointer hover:shadow-md hover:border-gray-300 transition-all">
            <div class="flex items-center justify-between mb-3">
              <div class="p-2 bg-gray-100 rounded-lg">
                <lucide-icon [img]="card.icon" [size]="18" class="text-gray-700"></lucide-icon>
              </div>
              <span class="text-2xl font-semibold text-gray-900">{{ card.value || '--' }}</span>
            </div>
            <h3 class="text-sm font-medium text-gray-600 mb-1">{{ card.title }}</h3>
            <p class="text-xs text-gray-500">{{ card.detail || 'Sem dados' }}</p>
          </div>
        </div>

        <!-- Error State -->
        <div *ngIf="(appStatus$ | async)?.error" class="mt-6">
          <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
            <h3 class="text-sm font-medium text-red-800 mb-2">Erro na sincronização</h3>
            <p class="text-sm text-red-600 mb-3">{{ (appStatus$ | async)?.error }}</p>
            <button (click)="forceSync()"
              class="inline-flex items-center px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md hover:bg-red-700 transition-colors">
              <lucide-icon [img]="RefreshCw" [size]="14" class="mr-2"></lucide-icon>
              Tentar novamente
            </button>
          </div>
        </div>
      </div>

      <!-- patrol_alerts section -->
      <!-- @if (activeSection.key==='patrol_alerts') {
        @defer (when activeSection.key==='patrol_alerts'; prefetch on idle) {
          <app-patrol-alerts></app-patrol-alerts>
        } @loading {
          <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      } -->
      
      <!-- Alerts section -->
      @if (activeSection.key==='alerts') {
        @defer (when activeSection.key==='alerts'; prefetch on idle) {
          <app-alerts-page></app-alerts-page>
        } @loading {
          <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }
      <!-- Check-ins section -->
      @if (activeSection.key==='checkins') {
        @defer (when activeSection.key==='checkins'; prefetch on idle) {
          <app-checkins-list></app-checkins-list>
        } @loading {
          <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!-- Rotation -->
      @if (activeSection.key==='patrols') {
        @defer (when activeSection.key==='patrols'; prefetch on idle) {
          <app-patrols-list></app-patrols-list>
        } @loading {
          <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!-- Guards -->
      @if (activeSection.key==='guards') {
        @defer (when activeSection.key==='guards'; prefetch on idle) {
          <app-guards-list></app-guards-list>
        } @loading {
         <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!-- Supervisor -->
      @if (activeSection.key==='supervisors') {
      @defer (when activeSection.key==='supervisors'; prefetch on idle) {
      <app-supervision></app-supervision>
      } @loading {
      <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
      }
      }
      <!-- Devices -->
      @if (activeSection.key==='devices') {
        @defer (when activeSection.key==='devices'; prefetch on idle) {
         <app-devices-list (navigateTo)="navigateToPage($event)"></app-devices-list>
        } @loading {
         <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }
      <!-- Teltonika Tracking -->
      @if (activeSection.key==='teltonika') {
        @defer (when activeSection.key==='teltonika'; prefetch on idle) {
          <app-teltonika-tracking></app-teltonika-tracking>
        } @loading {
         <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }
      <!-- Users -->
      @if (activeSection.key==='users') {
        @defer (when activeSection.key==='users'; prefetch on idle) {
         <app-users-list></app-users-list>
        } @loading {
          <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!-- Position -->
      @if (activeSection.key==='positions') {
        @defer (when activeSection.key==='positions'; prefetch on idle) {
          <app-positions-list></app-positions-list>
        } @loading {
         <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!-- solicition -->
      @if (activeSection.key==='requests') {
        @defer (when activeSection.key==='requests'; prefetch on idle) {
          <app-access-requests-list></app-access-requests-list>
        } @loading {
         <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!--Connections  -->
      @if (activeSection.key==='connections') {
        @defer (when activeSection.key==='connections'; prefetch on idle) {
         <app-whatsapp-connections></app-whatsapp-connections>
        } @loading {
         <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
        }
      }

      <!-- Notifications -->
      @if (activeSection.key==='notifications') {
      @defer (when activeSection.key==='notifications'; prefetch on idle) {
      <app-notifications-list></app-notifications-list>
      } @loading {
      <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
      }
      }

      <!-- Establishment component -->
      @if (activeSection.key==='establishments') {
      @defer (when activeSection.key==='establishments'; prefetch on idle) {
      <app-establishment-list></app-establishment-list>
      } @loading {
      <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
      }
      }

      <!-- Establishment component -->
      @if (activeSection.key==='access_records') {
      @defer (when activeSection.key==='access_records'; prefetch on idle) {
      <app-access-record-list></app-access-record-list>
      } @loading {
      <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
      }
      }

      <!-- Establishment component -->
      @if (activeSection.key==='vehicle_access') {
      @defer (when activeSection.key==='vehicle_access'; prefetch on idle) {
      <app-establishment-block></app-establishment-block>
      } @loading {
      <ng-container *ngTemplateOutlet="sectionLoading"></ng-container>
      }
      }

    </main>
  </div>
</div>

<!-- Modal de Notificação -->
<app-notification-modal *ngIf="showNotificationModal && selectedPositionForNotification"
  [positionId]="selectedPositionForNotification.id" [positionName]="selectedPositionForNotification.name"
  (close)="closeNotificationModal()" (notificationSent)="onNotificationSent($event)">
</app-notification-modal>

<ng-template #sectionLoading>
  <div class="max-w-7xl mx-auto space-y-4">
    <div class="h-8 w-48 bg-gray-200 rounded-md animate-pulse"></div>
    <div class="bg-white rounded-lg border border-gray-200 shadow-sm p-6 space-y-4">
      <div class="h-4 w-2/3 bg-gray-200 rounded animate-pulse"></div>
      <div class="h-4 w-1/2 bg-gray-200 rounded animate-pulse"></div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
        <div class="h-24 bg-gray-100 rounded-lg animate-pulse"></div>
        <div class="h-24 bg-gray-100 rounded-lg animate-pulse"></div>
        <div class="h-24 bg-gray-100 rounded-lg animate-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>
